if (!customElements.get('bb-category-carousel')) customElements.define('bb-category-carousel', class extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.bb-category-carousel-track');
    this.previous = this.querySelector('[data-carousel-previous]');
    this.next = this.querySelector('[data-carousel-next]');
    this.abort = new AbortController();
    const options = {signal:this.abort.signal};
    this.update = () => {
      this.previous.disabled = this.track.scrollLeft <= 4;
      this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
    };
    const move = direction => this.track.scrollBy({left:direction * Math.max(140,Math.floor(this.track.clientWidth / 140) * 140),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    this.previous.addEventListener('click',()=>move(-1),options);
    this.next.addEventListener('click',()=>move(1),options);
    this.track.addEventListener('scroll',this.update,{...options,passive:true});
    this.track.addEventListener('keydown',event=>{if(event.target===this.track&&['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();move(event.key==='ArrowLeft'?-1:1);}},options);
    this.resize = new ResizeObserver(this.update);
    this.resize.observe(this.track);
    this.update();
  }
  disconnectedCallback() {this.abort?.abort();this.resize?.disconnect();}
});
